






















































import { Component, Vue, Ref } from "vue-property-decorator";
import EVisitorTable from "@/components/EVisitorTable.vue";
import GlobalFilterSensitiveMixin from "@/mixins/GlobalFilterSensitiveMixin";
import ReservationModal from "@/components/reservation-form/ReservationModal.vue";

@Component({
  components: {
    EVisitorTable,
    ReservationModal,
  },
  mixins: [GlobalFilterSensitiveMixin],
})
export default class EVisitors extends Vue {
  reservationModalOpen = false;
  reservationId = 0;

  async openReservation(id: number) {
    this.reservationId = id;
    let reservationExists = false;
    
    await Vue.axios
      .get<boolean>(`Reservations/ReservationExists/${this.reservationId}`)
      .then((res) => {
        reservationExists = res.data;

        if(reservationExists){
          this.reservationModalOpen = true;
        }
        else{        
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("Reservation.Deleted"),
            timeout: 5000,
          });
        }
      });  
  }

  @Ref("notCheckedIn") notCheckedInTable?: EVisitorTable;
  @Ref("checkedIn") checkedInTable?: EVisitorTable;
  @Ref("checkedOut") checkedOutTable?: EVisitorTable;

  refreshAll() {
    this.notCheckedInTable?.refresh();
    this.checkedInTable?.refresh();
    this.checkedOutTable?.refresh();
  }

  get tab() {
    const tab = this.$route.query.tab;
    return tab && !isNaN(+tab) ? +tab - 1 : 0;
  }

  set tab(fresh: number) {
    this.$router.replace({
      path: this.$route.path,
      params: this.$route.params,
      query: { tab: (fresh + 1).toString() },
      replace: true,
    });
  }
}
